module.exports = __webpack_public_path__ + "static/img/3662_phase_function_Paper_PointsHejduk_Prediction.65a6df2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3662_phase_function_Paper_PointsHejduk_Prediction.png
// module id = a8kx
// module chunks = 0